const typeColorObject = {
  'normal': {
    'cardBackground': 'hover:bg-stone-300',
    // 'cardBorder': 'hover:border-stone-400',
    'background': 'bg-stone-500',
    'border': 'border-stone-600'
  },
  'fire': {
    'cardBackground': 'hover:bg-red-300',
    // 'cardBorder': 'hover:border-red-400',
    'background': 'bg-red-700',
    'border': 'border-red-800'
  },
  'water': {
    'cardBackground': 'hover:bg-blue-300',
    // 'cardBorder': 'hover:border-blue-400',
    'background': 'bg-blue-700',
    'border': 'border-blue-800'
  },
  'electric': {
    'cardBackground': 'hover:bg-yellow-300',
    // 'cardBorder': 'hover:border-yellow-400',
    'background': 'bg-yellow-500',
    'border': 'border-yellow-600',
  },
  'grass': {
    'cardBackground': 'hover:bg-green-300',
    // 'cardBorder': 'hover:border-green-400',
    'background': 'bg-green-700',
    'border': 'border-green-800',
  },
  'ice': {
    'cardBackground': 'hover:bg-cyan-300',
    // 'cardBorder': 'hover:border-cyan-400',
    'background': 'bg-cyan-500',
    'border': 'border-cyan-600'
  },
  'fighting': {
    'cardBackground': 'hover:bg-amber-300',
    // 'cardBorder': 'hover:border-amber-400',
    'background': 'bg-amber-800',
    'border': 'border-amber-900'
  },
  'poison': {
    'cardBackground': 'hover:bg-fuchsia-300',
    // 'cardBorder': 'hover:border-fuchsia-400',
    'background': 'bg-fuchsia-800',
    'border': 'border-fuchsia-900'
  },
  'ground': {
    'cardBackground': 'hover:bg-amber-200',
    // 'cardBorder': 'hover:border-amber-300',
    'background': 'bg-amber-700',
    'border': 'border-amber-800'
  },
  'flying': {
    'cardBackground': 'hover:bg-sky-300',
    // 'cardBorder': 'hover:border-sky-400',
    'background': 'bg-sky-400',
    'border': 'border-sky-500'
  },
  'psychic': {
    'cardBackground': 'hover:bg-rose-300',
    // 'cardBorder': 'hover:border-rose-400',
    'background': 'bg-rose-500',
    'border': 'border-rose-600'
  },
  'bug': {
    'cardBackground': 'hover:bg-lime-300',
    // 'cardBorder': 'hover:border-lime-400',
    'background': 'bg-lime-600',
    'border': 'border-lime-700'
  },
  'rock': {
    'cardBackground': 'hover:bg-yellow-200',
    // 'cardBorder': 'hover:border-yellow-300',
    'background': 'bg-yellow-800',
    'border': 'border-yellow-900'
  },
  'ghost': {
    'cardBackground': 'hover:bg-purple-300',
    // 'cardBorder': 'hover:border-purple-400',
    'background': 'bg-purple-600',
    'border': 'border-purple-700'
  },
  'dragon': {
    'cardBackground': 'hover:bg-violet-300',
    // 'cardBorder': 'hover:border-violet-400',
    'background': 'bg-violet-800',
    'border': 'border-violet-900'
  },
  'dark': {
    'cardBackground': 'hover:bg-neutral-300',
    // 'cardBorder': 'hover:border-neutral-400',
    'background': 'bg-neutral-700',
    'border': 'border-neutral-800'
  },
  'steel': {
    'cardBackground': 'hover:bg-zinc-300',
    // 'cardBorder': 'hover:border-zinc-400',
    'background': 'bg-zinc-400',
    'border': 'border-zinc-500'
  },
  'fairy': {
    'cardBackground': 'hover:bg-pink-300',
    // 'cardBorder': 'hover:border-pink-400',
    'background': 'bg-pink-500',
    'border': 'border-pink-600',
  }
}

export default typeColorObject;